import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// ID-039 RC-CS-REC-001: admin-only reopen of a declined request with an explicit fee decision (ID-044: terracotta highlight)
export function ReopenPanel({ active, busy, act }) {
  const p = active.proposal || {};
  const outstanding = p.total_due && !p.paid && !p.waived ? p.total_due : 0;
  const [decision, setDecision] = useState(outstanding ? "DUE" : "WAIVED");
  const [amount, setAmount] = useState(String(outstanding || ""));
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const submit = () => act(() => api.post(`/admin/custom-studio/${active.id}/reopen`, {
    decision, amount: parseFloat(amount) || 0, reason, internal_note: note,
  }), "Request reopened");
  return (
    <div className="rounded-md bg-terracotta p-5 text-white shadow-sm" data-testid="admin-reopen-panel">
      <p className="text-sm font-semibold">Reopen this declined request</p>
      <p className="mt-1 text-xs text-white/90">Resumes from {active.revision_ref}. Earlier fees, payments and history stay on record.</p>
      <div className="mt-3 rounded-md bg-[#FAF8F3] p-4 text-charcoal" data-testid="admin-reopen-form">
        <p className="text-xs text-charcoal">{outstanding ? `Outstanding fee: $${outstanding.toFixed(2)} (${p.summary}).` : "No outstanding fee."}</p>
        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <Select value={decision} onValueChange={setDecision}>
            <SelectTrigger className="h-9 border-charcoal/30 bg-white" data-testid="reopen-decision"><SelectValue /></SelectTrigger>
            <SelectContent>
              {outstanding > 0 && <SelectItem value="DUE">Fee is due as proposed</SelectItem>}
              <SelectItem value="CORRECTED">Fee needs correction</SelectItem>
              <SelectItem value="WAIVED">Waive the fee</SelectItem>
            </SelectContent>
          </Select>
          {decision === "CORRECTED" && <Input type="number" min="0" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Corrected amount (USD)" className="h-9 border-charcoal/30 bg-white" data-testid="reopen-amount" />}
          <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (the dealer sees this)" className="h-9 border-charcoal/30 bg-white sm:col-span-2" data-testid="reopen-reason" />
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Internal note (admin only, optional)" className="h-9 border-charcoal/30 bg-white sm:col-span-2" data-testid="reopen-internal-note" />
        </div>
        <Button className="mt-3 bg-charcoal px-5 font-semibold text-white hover:bg-charcoal/90" disabled={busy || !reason.trim()} onClick={submit} data-testid="reopen-submit">Reopen request</Button>
      </div>
    </div>
  );
}
